import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Gallery, GalleryItem, ImageItem } from 'ng-gallery';
import { HelpersService } from 'src/app/services/shared/helper.service';

@Component({
  selector: 'app-image-modal',
  templateUrl: './image-modal.component.html',
  styleUrls: ['./image-modal.component.scss']
})
export class ImageModalComponent implements OnInit {

  images: any[];
  items: GalleryItem[];

  constructor(
    public dialogRef: MatDialogRef<ImageModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private gallery: Gallery,
    public helper: HelpersService
  ) {
    this.images = data.images;
    this.items = data.images.map(item => {
      return new ImageItem({src: helper.parseRelPath(item.file.rel_path), thumb: helper.parseRelPath(item.file.rel_path)})
    })
  }

  ngOnInit(): void {
    const galleryRef = this.gallery.ref('gallery');
    galleryRef.load(this.items);
  }

}
